import {
  convertToCamelCase,
  convertToSnakeCase,
} from "../../redux/actions/helpers";
import { dataFormatter } from "./index";
import Cookies from "js-cookie";
import axios from "axios";

export const loadSuperAdmins = async (page) => {
  const response = await axios
    .get(`/api/v1/super_admins?page=${page}`, {
      headers: {
        Authorization: `Bearer ${
          Cookies.get("jwt") || localStorage.getItem("jwt")
        }`,
      },
    })
    .catch((errors) => {
      throw errors.message;
    });

  if (response.status === 200) {
    const meta = JSON.parse(response.request.response)["meta"];
    const results = dataFormatter.deserialize(response.data).map((obj) => {
      return convertToCamelCase(obj);
    });

    return { results: results, meta: meta };
  }
};

export const loadSuperAdmin = async (id) => {
  const response = await axios
    .get(`/api/v1/super_admins/${id}`, {
      headers: {
        Authorization: `Bearer ${
          Cookies.get("jwt") || localStorage.getItem("jwt")
        }`,
      },
    })
    .catch((error) => {
      throw error;
    });

  if (response.status === 200) {
    return convertToCamelCase(dataFormatter.deserialize(response.data));
  }
};

export const createSuperAdmin = async (formData) => {
  const response = await axios
    .post(
      "/api/v1/super_admins",
      {
        data: { attributes: convertToSnakeCase(formData) },
      },
      {
        headers: {
          Authorization: `Bearer ${
            Cookies.get("jwt") || localStorage.getItem("jwt")
          }`,
        },
      }
    )
    .catch((error) => {
      throw error;
    });

  if (response.status === 200) {
    return convertToCamelCase(dataFormatter.deserialize(response.data));
  }
};

export const updateSuperAdmin = async (formData, id) => {
  const response = await axios
    .put(
      `/api/v1/super_admins/${id}`,
      {
        data: { attributes: convertToSnakeCase(formData) },
      },
      {
        headers: {
          Authorization: `Bearer ${
            Cookies.get("jwt") || localStorage.getItem("jwt")
          }`,
        },
      }
    )
    .catch((error) => {
      throw error;
    });

  if (response.status === 200) {
    return convertToCamelCase(dataFormatter.deserialize(response.data));
  }
};

export const deleteSuperAdmin = async (id) => {
  const response = await axios
    .delete(`/api/v1/super_admins/${id}`, {
      headers: {
        Authorization: `Bearer ${
          Cookies.get("jwt") || localStorage.getItem("jwt")
        }`,
      },
    })
    .catch((error) => {
      throw error;
    });
  if (response.status === 200) {
    return convertToCamelCase(dataFormatter.deserialize(response.data));
  }
};
